/* Copyright (c) 2020-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useGetPlanQuery } from "~/generated/graphql";

type Props = {
  planId: string;
};

export function useGetPlan({ planId }: Props) {
  const { data, loading, error, refetch } = useGetPlanQuery({
    variables: { planId },
  });

  return { plan: data?.plan ?? undefined, loading, error, refetch } as const;
}
